export var TITLE = 'Baichuan';
export var TEXT_MULTIPLE = 1;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#FF6933';
export var COLOR_GRADIENT = 'linear-gradient(-45deg, #FF6933, #FEC13E)';